import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@repo/shared-styles";

type Props = {
    children: React.ReactNode;
};

/**
 * Component to help maintain consistency between filters spacing
 * and alignment.
 */
class FiltersContainer extends React.Component<Props> {
    createChildren: () => React.ReactNode = () => {
        const {children} = this.props;
        const count = React.Children.count(children);
        return React.Children.map(children, (child, index) => {
            // Ignore child that won't be rendered.
            if (!child) {
                return null;
            }

            return (
                <React.Fragment>
                    {/* @ts-expect-error - TS2769 - No overload matches this call. */}
                    {React.cloneElement(child, {
                        // @ts-expect-error - TS2339 - Property 'props' does not exist on type 'string | number | true | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal'.
                        ...child.props,
                        // We apply the child's style the last so that the
                        // filter style can override.
                        // @ts-expect-error - TS2339 - Property 'props' does not exist on type 'string | number | true | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal'.
                        style: [styles.filter, child.props.style],
                        key: index,
                    })}
                    {/* Don't render Strut after the last filter */}
                    {index !== count - 1 && <Strut size={spacing.medium_16} />}
                </React.Fragment>
            );
        });
    };

    render(): React.ReactNode {
        return (
            <View style={styles.filtersContainer}>{this.createChildren()}</View>
        );
    }
}

const styles = StyleSheet.create({
    filtersContainer: {
        alignItems: "center",
        flexDirection: "row",
        width: "100%",
        [mediaQueries.smOrSmaller]: {
            flexDirection: "column",
        },
    },
    filter: {
        maxWidth: 240,
        width: "100%",
        [mediaQueries.smOrSmaller]: {
            maxWidth: "none",
        },
    },
});

export default FiltersContainer;
